import {useEffect, useState} from 'react';  
import OECloseIcon from '../assets/images/Illustrations/OE-Close.svg';
import OEIcon from '../assets/images/Illustrations/OE-Icon.svg';
import Cookies from 'js-cookie';
import { Button } from 'react-bootstrap';
import { getApiService } from '../services/ApiService';
import { GetPayLoad } from '../services/PayLoadStorage';
import parse from 'html-react-parser';
import { getCookieOptions } from '../utils/cookieUtils';

const RenewalModal = ({ onClose }) => {
    
    const Payload = GetPayLoad('PayLoad');
    const [renewalContent, setRenewalContent] = useState([]);
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const headers = {
            "X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
            "X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
            "X-Hps-Region": Payload?.region,
            "X-Hps-Carrier": Payload?.owning_carrier
        };
    const lang = Cookies.get('lang') || 'eng';
    const siteCd = Payload?.site_cd || '';
    const [showContent, setShowContent] = useState(false); 

    useEffect(() => {

        if(siteCd !== '') {
            const page = 'renewal'; 
            const targetUrl = process.env.REACT_APP_API_CMS_CONTENT_ENDPOINT;            
            getApiService(
                baseUrl,
                targetUrl,
                {
                    page: page,
                    site_cd: siteCd,
                    lang: lang
                },
                headers
            )
            .then((response) => {
                if(response?.data && response.data.status === 'SUCCESS'){
                    const result = response.data.data;
                    setRenewalContent(result?.renewal);
                    setShowContent(true);
                }
            })
            .catch((error) =>{
                console.log(error);
            })
        }
    }, [lang]);

    // Logic for reminding later
    const handleRemindMeLater = () => {
        let date = new Date();
        date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
        Cookies.set('showRenewalPopup', 'true', { expires: date, ...getCookieOptions() });
        onClose(); //Close the modal
    }
    // Logic for not reminding again
    const handleDontRemindMeAgain = () => {
        let date = new Date();
        date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
        Cookies.set('showRenewalPopup', 'false', { expires: date, ...getCookieOptions() });
        onClose(); //Close the modal
    }
    
    return (
        <div class="OE-fade">
            {
                showContent && 
                <div class="OE-Content px-4 py-4 text-center position-relative">
                    <img src = {OECloseIcon} onClick={() => onClose()} class="position-absolute" id="close" style={{cursor: 'pointer'}} alt='Close icon' />
                    <img src = {OEIcon} width="79" height="79" alt='OE icon' />
                    {parse(renewalContent?.renewal_modal_popup_content || '')}
                    <div class="d-grid mt-3">
                        <Button 
                            className="btn-lg" 
                            onClick={handleDontRemindMeAgain}
                            type='button'
                            variant='outline-secondary'
                        >
                        {renewalContent?.renewal_modal_popup_dont_remind_btn}
                        </Button>
                        <Button
                            className="btn-lg mt-3 mb-3" 
                            onClick={handleRemindMeLater}
                            type='button'
                            variant='secondary'
                        >
                        {renewalContent?.renewal_modal_popup_remind_later_btn}
                        </Button>
                    </div>
                </div>
            }
        </div>
    );
};

export default RenewalModal;